import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const ServiceCard = ({ service, index = 0 }) => {
  const Icon = service.icon;
  return (
    <Reveal delay={index * 0.08} className="h-full">
      <Link
        to={`/services/${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="group flex h-full flex-col rounded-2xl border border-kryvo-line bg-white p-7 shadow-[0_6px_30px_-14px_rgba(6,78,42,0.12)] transition-all duration-300 hover:-translate-y-1.5 hover:border-kryvo-green/40 hover:shadow-[0_24px_50px_-20px_rgba(8,122,61,0.25)]"
      >
        <span className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-kryvo-soft text-kryvo-green transition-colors duration-300 group-hover:bg-kryvo-green group-hover:text-white">
          <Icon className="h-6 w-6" aria-hidden="true" />
        </span>
        <h3 className="mb-2.5 text-xl font-semibold text-kryvo-ink">{service.name}</h3>
        <p className="mb-6 flex-1 text-sm leading-relaxed text-kryvo-ink/65">{service.shortDesc}</p>
        <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-kryvo-green">
          Learn More
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
        </span>
      </Link>
    </Reveal>
  );
};

export default ServiceCard;
